<template>
  <div style="width: 100%;height: 100%;" class="body2">
    <div class="all">
      <div class="main">
        <div class="top_bg2">
          <headers pageType="magicApplyIndex"></headers>
          <div class="position">
            <div class="wraper"><p><a href="javascript:void(0)" @click="urlTo('home')">首页</a> / <span>法人办事</span></p></div>
          </div>
        </div>
        <div class="fixed">
          <fixedDiv></fixedDiv>
        </div>
        <div class="wraper">
          <div class="civil_part1">
            <h2 class="tit">养老服务</h2>
            <ul>
              <li style="padding-right: 30px" class="none"><a href="javascript:void(0)"   @click="urlTo2('guideIndex',{service_code:'OLD',nav_name:'高龄津贴'})"  class="civil_icon1"><img src="../../static/new_imgs/yljgjsxk.png"><span>
养老机构设立许可</span></a></li>
              <li style="padding-right: 30px" class="none"><a href="javascript:void(0)"   @click="urlTo2('magicApply',{archive_type_code:'pension_reg',nav_name:'养老机构备案'})"  class="civil_icon2"><img src="../../static/new_imgs/yljgba.png"><span>养老机构备案</span></a></li>
              <li style="padding-right: 30px" class="none"><a href="javascript:void(0)"   @click="urlTo2('guideIndex',{service_code:'OLD',nav_name:'高龄津贴'})"  class="civil_icon3"><img src="../../static/new_imgs/ylfwssb.png"><span>养老服务商申办</span></a></li>
            </ul>

          </div>
        </div>

        <div class="clear"></div>
        <div class="wraper">
          <div class="civil_part1">
            <h2 class="tit">区划地名</h2>
            <ul style="margin-bottom: 100px">
              <li style="padding-right: 30px" class="none"><a href="javascript:void(0)"   @click="urlTo2('magicApply',{archive_type_code:'social_area_name',nav_name:'申请地名证明'})"  class="civil_icon4"><img src="../../static/new_imgs/xmdj.png"><span>申请地名证明</span></a></li>
            </ul>
          </div>
        </div>
        <div class="clear"></div>
        <div class="wraper">
          <div class="civil_part1">
            <h2 class="tit">社会事务</h2>
            <ul>

              <li style="padding-right: 30px" class="none"><a href="javascript:void(0)"   @click="urlTo2('magicApply',{archive_type_code:'funeral_new_cemetery',nav_name:'公墓建设申请'})"  class="civil_icon5"><img src="../../static/new_imgs/jsgysmd.png"><span>公墓建设申请</span></a></li>
              <li style="padding-right: 30px" class="none"><a href="javascript:void(0)"   @click="urlTo2('magicApply',{archive_type_code:'funeral_new_funeral_home',nav_name:'建设殡仪馆申请'})"  class="civil_icon6"><img src="../../static/new_imgs/jsbyfwsq.png"><span>建设殡仪馆申请</span></a></li>
              <li style="padding-right: 30px" class="none"><a href="javascript:void(0)"   @click="urlTo2('magicApply',{archive_type_code:'funeral_new_ashes_build',nav_name:'建设骨灰堂申请'})"  class="civil_icon3"><img src="../../static/new_imgs/jdghtsq.png"><span>
建设骨灰堂申请</span></a></li>
              <li  class="none"><a href="javascript:void(0)"   @click="urlTo2('magicApply',{archive_type_code:'welfare_new_build',nav_name:'建设福利机构申请'})"  class="civil_icon4"><img src="../../static/new_imgs/jsjyxgm.png"><span>
建设福利机构申请</span></a></li>
            </ul>

          </div>
        </div>

        <div class="clear"></div>
        <div class="wraper">
          <div  class="civil_part1">
            <h2 class="tit">社会组织</h2>
            <ul style="margin-bottom: 100px">
              <li style="padding-right: 30px" class="none"><a href="javascript:void(0)"  @click="urlTo2('servicesAppointmentMarry','marry','结婚登记预约')"  class="civil_icon7"><img src="../../static/new_imgs/stcldj.png"><span>社团成立登记</span></a></li>
              <li style="padding-right: 30px" class="none"><a href="javascript:void(0)"  @click="urlTo2('servicesAppointmentMarry','divorce','离婚登记预约')"  class="civil_icon1"><img src="../../static/new_imgs/stbgdj.png"><span>
社团变更登记</span></a></li>
              <li style="padding-right: 30px" class="none"><a href="javascript:void(0)"  @click="urlTo2('servicesAppointmentMarry','new_marry_card','补领结婚证预约')"  class="civil_icon1"><img src="../../static/new_imgs/stzxdj.png"><span>社团注销登记</span></a></li>
              <li style="" class="none"><a href="javascript:void(0)"   @click="urlTo2('servicesAppointmentMarry','new_divorce_card','补领离婚证预约')"  class="civil_icon2"><img src="../../static/new_imgs/stzchz.png"><span>
社团章程核准</span></a></li>
            </ul>
            <ul style="margin-bottom: 100px">
              <li style="padding-right: 30px" class="none"><a href="javascript:void(0)"   @click="urlTo2('funeralAppointment','funeral','殡葬业务预约')" class="civil_icon3"><img src="../../static/new_imgs/stzsbb.png"><span>
社团证书补办</span></a></li>
              <li style="padding-right: 30px" class="none"><a href="javascript:void(0)"  @click="urlTo2('magicApply',{archive_type_code:'mission_reg',nav_name:'社团慈善组织认定'})" class="civil_icon4"><img src="../../static/new_imgs/stcszzrd.png"><span>社团慈善组织认定</span></a></li>
              <li style="padding-right: 30px" class="none"><a href="javascript:void(0)"   @click="urlTo2('helpSweepingAppointment','help_sweep','代为扫墓预约')" class="civil_icon5"><img src="../../static/new_imgs/stgmzgrd.png"><span>社团公募资格认定</span></a></li>
              <li  class="none"><a href="javascript:void(0)"   @click="urlTo2('helpSweepingAppointment','help_sweep','代为扫墓预约')" class="civil_icon3"><img src="../../static/new_imgs/stzfgmfw.png"><span>社团政府购买服务</span></a></li>


            </ul>
            <ul style="margin-bottom: 100px">
              <li style="padding-right: 30px" class="none"><a href="javascript:void(0)"   @click="urlTo2('funeralAppointment','funeral','殡葬业务预约')" class="civil_icon6"><img src="../../static/new_imgs/stmjfaba.png"><span>社团募捐方案备案</span></a></li>
              <li style="padding-right: 30px" class="none"><a href="javascript:void(0)"  @click="urlTo2('tombSweepingAppointment','sweep','扫墓预约')" class="civil_icon7"><img src="../../static/new_imgs/stjzccyt.png"><span>社团捐赠财产用途</span></a></li>
              <li style="padding-right: 30px" class="none"><a href="javascript:void(0)"   @click="urlTo2('helpSweepingAppointment','help_sweep','代为扫墓预约')" class="civil_icon1"><img src="../../static/new_imgs/stzdsxbg.png"><span>社团重大事项报告</span></a></li>
              <li  class="none"><a href="javascript:void(0)"   @click="urlTo2('helpSweepingAppointment','help_sweep','代为扫墓预约')" class="civil_icon3"><img src="../../static/new_imgs/stnjnb.png"><span>社团年检年报</span></a></li>
            </ul>
            <ul style="margin-bottom: 100px">
              <li style="padding-right: 30px" class="none"><a href="javascript:void(0)"   @click="urlTo2('funeralAppointment','funeral','殡葬业务预约')" class="civil_icon2"><img src="../../static/new_imgs/stpg.png"><span>社团评估</span></a></li>
              <li style="padding-right: 30px" class="none"><a href="javascript:void(0)"  @click="urlTo2('tombSweepingAppointment','sweep','扫墓预约')" class="civil_icon3"><img src="../../static/new_imgs/stjbts.png"><span>社团举报投诉</span></a></li>
              <li style="padding-right: 30px" class="none"><a href="javascript:void(0)"   @click="urlTo2('helpSweepingAppointment','help_sweep','代为扫墓预约')" class="civil_icon4"><img src="../../static/new_imgs/mfcldj.png"><span>民非成立登记</span></a></li>
              <li  class="none"><a href="javascript:void(0)"   @click="urlTo2('helpSweepingAppointment','help_sweep','代为扫墓预约')" class="civil_icon5"><img src="../../static/new_imgs/mfbgdn.png"><span>民非变更登记</span></a></li>
            </ul>
            <ul style="margin-bottom: 100px">
              <li style="padding-right: 30px" class="none"><a href="javascript:void(0)"   @click="urlTo2('funeralAppointment','funeral','殡葬业务预约')" class="civil_icon6"><img src="../../static/new_imgs/mfzxdj.png"><span>民非注销登记</span></a></li>
              <li style="padding-right: 30px" class="none"><a href="javascript:void(0)"  @click="urlTo2('tombSweepingAppointment','sweep','扫墓预约')" class="civil_icon7"><img src="../../static/new_imgs/mfzchz.png"><span>民非章程核准</span></a></li>
              <li style="padding-right: 30px" class="none"><a href="javascript:void(0)"   @click="urlTo2('helpSweepingAppointment','help_sweep','代为扫墓预约')" class="civil_icon1"><img src="../../static/new_imgs/mfzsbb.png"><span>民非证书补办</span></a></li>
              <li  class="none"><a href="javascript:void(0)"   @click="urlTo2('helpSweepingAppointment','help_sweep','代为扫墓预约')" class="civil_icon2"><img src="../../static/new_imgs/mfcszzrd.png"><span>民非慈善组织认定</span></a></li>
            </ul>
            <ul style="margin-bottom: 100px">
              <li style="padding-right: 30px" class="none"><a href="javascript:void(0)"   @click="urlTo2('funeralAppointment','funeral','殡葬业务预约')" class="civil_icon3"><img src="../../static/new_imgs/mfgmzgrz.png"><span>民非公募资格认定</span></a></li>
              <li style="padding-right: 30px" class="none"><a href="javascript:void(0)"  @click="urlTo2('tombSweepingAppointment','sweep','扫墓预约')" class="civil_icon4"><img src="../../static/new_imgs/mfzfgmfw.png"><span>民非政府购买服务</span></a></li>
              <li style="padding-right: 30px" class="none"><a href="javascript:void(0)"   @click="urlTo2('helpSweepingAppointment','help_sweep','代为扫墓预约')" class="civil_icon5"><img src="../../static/new_imgs/mfmjfaba.png"><span>民非募捐方案备案</span></a></li>
              <li  class="none"><a href="javascript:void(0)"   @click="urlTo2('helpSweepingAppointment','help_sweep','代为扫墓预约')" class="civil_icon6"><img src="../../static/new_imgs/mfjzccyt.png"><span>民非捐赠财产用途</span></a></li>
            </ul>
            <ul style="margin-bottom: 100px">
              <li style="padding-right: 30px" class="none"><a href="javascript:void(0)"   @click="urlTo2('funeralAppointment','funeral','殡葬业务预约')" class="civil_icon7"><img src="../../static/new_imgs/mfzdsxbg.png"><span>民非重大事项报告</span></a></li>
              <li style="padding-right: 30px" class="none"><a href="javascript:void(0)"  @click="urlTo2('tombSweepingAppointment','sweep','扫墓预约')" class="civil_icon1"><img src="../../static/new_imgs/mfnjnb.png"><span>民非年检年报</span></a></li>
              <li style="padding-right: 30px" class="none"><a href="javascript:void(0)"   @click="urlTo2('helpSweepingAppointment','help_sweep','代为扫墓预约')" class="civil_icon2"><img src="../../static/new_imgs/mfpg.png"><span>民非评估</span></a></li>
              <li  class="none"><a href="javascript:void(0)"   @click="urlTo2('helpSweepingAppointment','help_sweep','代为扫墓预约')" class="civil_icon3"><img src="../../static/new_imgs/mfjbts.png"><span>民非举报投诉</span></a></li>
            </ul>
            <ul style="margin-bottom: 100px">
              <li style="padding-right: 30px" class="none"><a href="javascript:void(0)"   @click="urlTo2('funeralAppointment','funeral','殡葬业务预约')" class="civil_icon4"><img src="../../static/new_imgs/jjhcldj.png"><span>基金会成立登记</span></a></li>
              <li style="padding-right: 30px" class="none"><a href="javascript:void(0)"  @click="urlTo2('tombSweepingAppointment','sweep','扫墓预约')" class="civil_icon5"><img src="../../static/new_imgs/jjhbgdj.png"><span>基金会变更登记</span></a></li>
              <li style="padding-right: 30px" class="none"><a href="javascript:void(0)"   @click="urlTo2('helpSweepingAppointment','help_sweep','代为扫墓预约')" class="civil_icon6"><img src="../../static/new_imgs/jjhzxdj.png"><span>基金会注销登记</span></a></li>
              <li  class="none"><a href="javascript:void(0)"   @click="urlTo2('helpSweepingAppointment','help_sweep','代为扫墓预约')" class="civil_icon7"><img src="../../static/new_imgs/jjhzchz.png"><span>基金会章程核准</span></a></li>
            </ul>
            <ul style="margin-bottom: 100px">
              <li style="padding-right: 30px" class="none"><a href="javascript:void(0)"   @click="urlTo2('funeralAppointment','funeral','殡葬业务预约')" class="civil_icon1"><img src="../../static/new_imgs/jjhzsbb.png"><span>基金会证书补办</span></a></li>
              <li style="padding-right: 30px" class="none"><a href="javascript:void(0)"  @click="urlTo2('tombSweepingAppointment','sweep','扫墓预约')" class="civil_icon2"><img src="../../static/new_imgs/jjhcszzrd.png"><span>基金会慈善组织认定</span></a></li>
              <li style="padding-right: 30px" class="none"><a href="javascript:void(0)"   @click="urlTo2('helpSweepingAppointment','help_sweep','代为扫墓预约')" class="civil_icon3"><img src="../../static/new_imgs/jjhgmzgrd.png"><span>基金会公募资格认定</span></a></li>
              <li  class="none"><a href="javascript:void(0)"   @click="urlTo2('helpSweepingAppointment','help_sweep','代为扫墓预约')" class="civil_icon4"><img src="../../static/new_imgs/jjhzfgmfw.png"><span>基金会政府购买服务</span></a></li>
            </ul>
            <ul style="margin-bottom: 100px">
              <li style="padding-right: 30px" class="none"><a href="javascript:void(0)"   @click="urlTo2('funeralAppointment','funeral','殡葬业务预约')" class="civil_icon5"><img src="../../static/new_imgs/jjhmjfaba.png"><span>基金会募捐方案备案</span></a></li>
              <li style="padding-right: 30px" class="none"><a href="javascript:void(0)"  @click="urlTo2('tombSweepingAppointment','sweep','扫墓预约')" class="civil_icon6"><img src="../../static/new_imgs/jjhjzccyt.png"><span>基金会捐赠财产用途</span></a></li>
              <li style="padding-right: 30px" class="none"><a href="javascript:void(0)"   @click="urlTo2('helpSweepingAppointment','help_sweep','代为扫墓预约')" class="civil_icon7"><img src="../../static/new_imgs/jjhzdsxbg.png"><span>基金会重大事项报告</span></a></li>
              <li  class="none"><a href="javascript:void(0)"   @click="urlTo2('helpSweepingAppointment','help_sweep','代为扫墓预约')" class="civil_icon1"><img src="../../static/new_imgs/jjhnjnb.png"><span>基金会年检年报</span></a></li>
            </ul>
            <ul style="margin-bottom: 100px">
              <li style="padding-right: 30px" class="none"><a href="javascript:void(0)"   @click="urlTo2('funeralAppointment','funeral','殡葬业务预约')" class="civil_icon2"><img src="../../static/new_imgs/jjhpg.png"><span>基金会评估</span></a></li>
              <li style="padding-right: 30px" class="none"><a href="javascript:void(0)"  @click="urlTo2('tombSweepingAppointment','sweep','扫墓预约')" class="civil_icon3"><img src="../../static/new_imgs/jjhjbts.png"><span>基金会举报投诉</span></a></li>
            </ul>
          </div>
        </div>
        <div class="clear"></div>
        <div class="wraper">
          <div class="civil_part1">
            <h2 class="tit">基层政权与社区治理</h2>
            <ul style="margin-bottom: 100px">
              <li style="padding-right: 30px" class="none"><a href="javascript:void(0)"   @click="urlTo2('funeralAppointment','funeral','殡葬业务预约')" class="civil_icon4"><img src="../../static/new_imgs/xmdj.png"><span>选民登记</span></a></li>
            </ul>
          </div>
        </div>
        <div class="clear"></div>
        <!--<div class="wraper">-->
        <!--<div class="civil_part1">-->
        <!--<h2 class="tit">社会救助</h2>-->
        <!--<ul>-->
        <!--<li><a href="javascript:void(0)"   @click="urlTo2('guideIndex',{service_code:'BLAN',nav_name:'城乡低保'})" class="civil_icon1"><img src="../../static/images/civil_icon1.png"><span>城乡低保</span></a></li>-->
        <!--<li><a href="javascript:void(0)"   @click="urlTo2('guideIndex',{service_code:'NTF',nav_name:'特困供养'})"  class="civil_icon2"><img src="../../static/images/civil_icon2.png"><span>特困供养</span></a></li>-->
        <!--<li class="none"><a href="javascript:void(0)"   @click="urlTo2('guideIndex',{service_code:'TEMP',nav_name:'临时救助'})"  class="civil_icon3"><img src="../../static/images/civil_icon3.png"><span>临时救助</span></a></li>-->
        <!--</ul>-->
        <!--</div>-->
        <!--</div>-->


      </div>
    </div>
    <div style="line-height: 35px;">

    </div>
    <div class="clear"></div>
    <footers></footers>

  </div>
</template>

<script>
  import headers from "../components/Headers";
  import fixedDiv from "../components/FixedDiv";
  import footers from "../components/Footer";
  export default {
    name: "apply-index",
    components:{
      headers,fixedDiv,footers
    },
    data() {
      let _self=this;
      return {
        active: 'publicIndex',
        width:document.body.clientWidth+'px',
        height:document.body.clientHeight+'px',
        pageNum:1,
        pageSize:6,
        tsData:[],
        jyData:[],
        zxData:[],
        clauseShow:false,
        url:'',
        title:'',
        service_code:'',
      }
    } ,
    watch: {
      width(n,o){
        alert(n+'w')
      },
      height(n,o){
        alert(n+'h')
      },
    },
    created() {
      this.urlTo("home")
    },
    methods: {
      urlTo(url,params){
        this.$router.push({path:url,query:params||{}});
      },
     /* urlTo2(url,service_code,title){
        this.url=url;
        this.service_code=service_code;
        this.title=title;
        this.clauseShow=true;
      },*/
      urlTo2(url,params){
        this.$message({
          message: '暂未开放',
          type: 'warning'
        });
        // this.$router.push({path:url,query:params||{}});
      },
      clauseClose(){
        this.clauseShow=false;
        this.urlTo2(this.url,{service_code:this.service_code,title:this.title})
      },
    }
  }



</script>
<style>
  .publicity table td {
    padding: 0px 5px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/MagicApplyIndex.vue